import React from "react";

const ServicesPage = (props) => {
	return <div>{props.children}</div>;
};

export default ServicesPage;
